import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './Doctor.css'
const SectionOne = () => {
  return (
    <div className="section_one_doctor">
      <Container>
        <Row>
          <Col>
            <div>
              <h3 className="headingss_doctor">
                Doctor Consultation Services at <mark>SurgerySaathi</mark>
              </h3>
            </div>
          </Col>
          <Col>
            <div className="doctor_second_main_sec">
              <div className="doctor_second_heading">
                SurgerySaathi offers expert consultations for a range of
                specialized procedures to enhance your health and well-being.
                Our experienced consultants are here to guide you through the
                decision-making process, providing you with comprehensive
                information and recommendations tailored to your needs.
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SectionOne
